// src/directives/swipe.js
export default {
    beforeMount(el, binding) {
        let startX = 0;
        let threshold = 50; // distance minimale en px pour déclencher le swipe

        el.addEventListener('touchstart', e => {
            startX = e.changedTouches[0].screenX;
        });

        el.addEventListener('touchend', e => {
            let endX = e.changedTouches[0].screenX;
            let diff = endX - startX;
            if (diff > threshold && typeof binding.value.onSwipeRight === 'function') {
                binding.value.onSwipeRight();
            } else if (diff < -threshold && typeof binding.value.onSwipeLeft === 'function') {
                binding.value.onSwipeLeft();
            }
        });
    }
}
